import * as R from "ramda";

const vehicleDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "vehicleDropDown"], state);
const validAssetDetailsPlanned = (state: any) =>
  R.pathOr({}, ["MyOrder", "validAssetDetailsPlanned"], state);
const assetValidationPlannedFlag = (state: any) =>
  R.pathOr(false, ["MyOrder", "assetValidationPlannedFlag"], state);
const autoCompleteAssetPlanned = (state: any) =>
  R.pathOr([], ["MyOrder", "autoCompleteAssetPlanned"], state);
const catalogItem = (state: any) =>
  R.pathOr([{}], ["MyOrder", "catalogDetails"], state);
const VehicleTypeDropdown = (state: any) =>
  R.pathOr([], ["MyOrder", "VehicleTypeDropdown"], state);
const selectedBranchDetails = (state: any) =>
  R.pathOr({ branchId: 0 }, ["MyOrder", "selectedBranchDetails"], state);
const selectedVehicleType = (state: any) =>
  R.pathOr("", ["MyOrder", "selectedVehicleType"], state);
const orderDetails = (state: any) =>
  R.pathOr({}, ["MyOrder", "orderDetails"], state);
const NoOfDoorsDropdownList = (state: any) =>
  R.pathOr([], ["MyOrder", "NoOfDoorsDropdownList"], state);
const AssetSizeDropdownList = (state: any) =>
  R.pathOr([], ["MyOrder", "AssetSizeDropdownList"], state);
const PreferredModelDropdownList = (state: any) =>
  R.pathOr([], ["MyOrder", "PreferredModelDropdownList"], state);
const DriverTitles = (state: any) =>
  R.pathOr([], ["MyOrder", "driverTitles"], state);
const ReasonTypes = (state: any) =>
  R.pathOr([], ["MyOrder", "reasonTypes"], state);
const PreferredMake = (state: any) =>
  R.pathOr([], ["MyOrder", "preferredMakes"], state);
const GetItemDetailsGrowth = (state: any) =>
  R.pathOr([], ["MyOrder", "setItemDetailsGrowth"], state);
const AddRequestReason = (state: any) =>
  R.pathOr([], ["MyOrder", "AddRequestReason"], state);
const reasonInfo = (state: any) =>
  R.pathOr([], ["MyOrder", "reasonInfo"], state);
const addClickFlg = (state: any) =>
  R.pathOr(false, ["MyOrder", "addClickFlg"], state);
const VechicleTypeDropdownList = (state: any) =>
  R.pathOr([], ["MyOrder", "VechicleTypeDropdownList"], state);
const OrderResponse = (state: any) =>
  R.pathOr([], ["MyOrder", "OrderResponse"], state);
const filteredCatalogItemValues = (state: any) =>
  R.pathOr({}, ["MyOrder", "filteredCatalogItemValues"], state);
const isCreateOrderComplete = (state: any) =>
  R.pathOr(false, ["MyOrder", "isCreateOrderComplete"], state);
const BlobUrlListObj = (state: any) =>
  R.pathOr({}, ["MyOrder", "BlobUrlListObj"], state);
const isUploadComplete = (state: any) =>
  R.pathOr(false, ["MyOrder", "isUploadComplete"], state);
const getAssettypes = (state: any) =>
  R.pathOr([], ["MyOrder", "AssetTypes"], state);
const equipmentDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "equipmentDropDown"], state);
const seatingCapacityDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "seatingCapacityDropDown"], state);
const utilityManufactureDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "utilityManufactureDropDown"], state);
const UtilityEnclosedcabDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "UtilityEnclosedcabDropDown"], state);
const utilityCapacityDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "utilityCapacityDropDown"], state);
const trailermanufactureDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "trailermanufactureDropDown"], state);
const trailerStyleDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "trailerStyleDropDown"], state);
const trailerLengthDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "trailerLengthDropDown"], state);
const trailerFuelTankDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "trailerFuelTankDropDown"], state);
const trailerChargingStationDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "trailerChargingStationDropDown"], state);
const snowManufactureDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "snowManufactureDropDown"], state);
const snowCategoryDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "snowCategoryDropDown"], state);
const snowSizeDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "snowSizeDropDown"], state);
const snowTypeDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "snowTypeDropDown"], state);
const developmentCategoryDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "developmentCategoryDropDown"], state);
const developmentManufactureDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "developmentManufactureDropDown"], state);
const TreeManufactureDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "TreeManufactureDropDown"], state);
const TreeEquipmentDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "TreeEquipmentDropDown"], state);
const TreeHorsePowerDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "TreeHorsePowerDropDown"], state);
const TreeFuelTypeDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "TreeFuelTypeDropDown"], state);
const standardManufactureDropdown = (state: any) =>
  R.pathOr([], ["MyOrder", "standardManufactureDropdown"], state);
const standardcategoryDropdown = (state: any) =>
  R.pathOr([], ["MyOrder", "standardcategoryDropdown"], state);
const uploadedAttachmentDetails = (state: any) =>
  R.pathOr([], ["MyOrder", "uploadedAttachmentDetails"], state);

const stateAvailabilityDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "stateAvailabilityDropDown"], state);
const programStatusDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "programStatusDropDown"], state);
const annualHoursDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "annualHoursDropDown"], state);
const deckSizeDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "deckSizeDropDown"], state);
const deckTypeDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "deckTypeDropDown"], state);
const autonomousDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "autonomousDropDown"], state);
const manufacturerDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "manufacturerDropDown"], state);
const categoryDropDown = (state: any) =>
  R.pathOr([], ["MyOrder", "categoryDropDown"], state);

const editClickFlg = (state: any) =>
  R.pathOr(false, ["MyOrder", "editClickFlg"], state);
const editVehicleIndex = (state: any) =>
  R.pathOr(false, ["MyOrder", "editVehicleIndex"], state);
const editReasonValues = (state: any) =>
  R.pathOr(false, ["MyOrder", "editReasonValues"], state);
const isSaved = (state: any) => R.pathOr("", ["MyOrder", "isSaved"], state);
const StatusDropdownList = (state: any) => R.pathOr([], ["MyOrder", "StatusDropdownList"], state);
const ConditionDropdownList = (state: any) => R.pathOr([], ["MyOrder", "ConditionDropdownList"], state);
const getDropdownData = (state: any) => R.pathOr([], ["MyOrder", "dropdownData"], state);
const costCentersForGrid = (state: any) => R.pathOr([], ["MyOrder", "costCentersForGrid"], state);
const regionsForGrid = (state: any) => R.pathOr([], ["MyOrder", "regionsForGrid"], state);
const selectedReasonType = (state: any) => R.pathOr("", ["MyOrder", "selectedReasonType"], state);

const selectors = {
  vehicleDropDown,
  validAssetDetailsPlanned,
  assetValidationPlannedFlag,
  autoCompleteAssetPlanned,
  catalogItem,
  VehicleTypeDropdown,
  selectedBranchDetails,
  selectedVehicleType,
  orderDetails,
  NoOfDoorsDropdownList,
  AssetSizeDropdownList,
  PreferredModelDropdownList,
  DriverTitles,
  ReasonTypes,
  PreferredMake,
  GetItemDetailsGrowth,
  AddRequestReason,
  reasonInfo,
  addClickFlg,
  VechicleTypeDropdownList,
  OrderResponse,
  filteredCatalogItemValues,
  isCreateOrderComplete,
  isUploadComplete,
  BlobUrlListObj,
  getAssettypes,
  equipmentDropDown,
  seatingCapacityDropDown,
  utilityManufactureDropDown,
  UtilityEnclosedcabDropDown,
  utilityCapacityDropDown,
  trailermanufactureDropDown,
  trailerStyleDropDown,
  trailerLengthDropDown,
  trailerFuelTankDropDown,
  trailerChargingStationDropDown,
  snowManufactureDropDown,
  snowCategoryDropDown,
  snowSizeDropDown,
  snowTypeDropDown,
  developmentCategoryDropDown,
  developmentManufactureDropDown,
  TreeManufactureDropDown,
  TreeEquipmentDropDown,
  TreeHorsePowerDropDown,
  TreeFuelTypeDropDown,
  standardcategoryDropdown,
  standardManufactureDropdown,
  uploadedAttachmentDetails,
  stateAvailabilityDropDown,
  programStatusDropDown,
  annualHoursDropDown,
  deckSizeDropDown,
  deckTypeDropDown,
  autonomousDropDown,
  manufacturerDropDown,
  categoryDropDown,
  editClickFlg,
  editVehicleIndex,
  editReasonValues,
  isSaved,
  StatusDropdownList,
  ConditionDropdownList,
  getDropdownData,
  regionsForGrid,
  costCentersForGrid,
  selectedReasonType
};

export default selectors;
